import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { AlertService } from '../../../../../core/services/alert.service';
import { ResponsiblesService } from '../../../services/responsiblesServices.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ResponsibleRequestTypeLine } from '../../../models/responsibleRequestTypeLine';

@Component({
  selector: 'kt-responsible-request-type',
  templateUrl: './responsible-request-type.component.html',
  styleUrls: ['./responsible-request-type.component.scss']
})
export class ResponsibleRequestTypeComponent implements OnInit {

  responsibleRequestType: ResponsibleRequestTypeLine[];
  searchText;
  displayedColumns = ['responsibleName', 'requestType', 'line', 'options'];
  dataSource: MatTableDataSource<ResponsibleRequestTypeLine>;
  listFilters = [];
  filterValue = '';
  selectedFilter = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private responsibleRequestTypeService: ResponsiblesService,
    private alertService: AlertService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.getResponsibleRequestType();
    this.getFilterCriteria();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.filteredData.length == 0) {
      this.alertService.info("Responsable no encontrado");
    }
  }

  getResponsibleRequestType() {
    this.spinnerService.show()
    this.responsibleRequestTypeService.getResponsibleRequestType().subscribe(
      (list) => {
        this.responsibleRequestType = list
        this.dataSource = new MatTableDataSource(this.responsibleRequestType)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerService.hide()
      },
      (error) => {
        this.spinnerService.hide()
        switch (error.status) {
          case 401:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 403:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 500:
            return this.alertService.error(
              'Oop! Ha ocurrido un error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 0:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case undefined:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
        }
      }
    );
  }

  getFilterCriteria() {
    this.listFilters = [
      { id: 'responsible', value: 'Responsable' },
      { id: 'requestType', value: 'Tipo Solicitud' },
      { id: 'line', value: 'Linea' },
    ]
  }

  searchByCriteria() {
    this.dataSource.filterPredicate = (data: ResponsibleRequestTypeLine, filter: string) => {
      if(this.selectedFilter == 'responsible'){
        return data.responsibleName.toLowerCase().indexOf(filter.toLowerCase()) != -1;
      } else if(this.selectedFilter == 'requestType'){
        return data.requestTypeName.toLowerCase().indexOf(filter.toLowerCase()) != -1;
      }else if(this.selectedFilter == 'line'){
        return data.lineName.toLowerCase().indexOf(filter.toLowerCase()) != -1;
      }
    };
    this.dataSource.filter = (this.filterValue);
  }

  clean() {
    this.filterValue = ''
    this.selectedFilter = ''
    this.dataSource = new MatTableDataSource(this.responsibleRequestType);
  }
}